export default __webpack_public_path__ + "static/media/kpop.05c8344f.svg";